import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can change the visibility of a scoped package from the website or command line.`}</p>
    <p>{`You must be the owner of the user account or organization that owns the package in order to change package visibility.`}</p>
    <p>{`For more information about package visibility, see "`}<a parentName="p" {...{
        "href": "package-scope-access-level-and-visibility"
      }}>{`Package scope, access level, and visibility`}</a>{`".`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` You cannot change the visibility of an unscoped package. Only scoped packages with a paid subscription may be private.`}</p>
    </Note>
    <h2>{`Making a public package private`}</h2>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Making a package private requires a paid user account or organization. To sign up for a paid user or organization, go to `}<inlineCode parentName="p">{`https://www.npmjs.com/settings/account-name/billing`}</inlineCode>{`, replacing `}<inlineCode parentName="p">{`account-name`}</inlineCode>{` with the name of your npm user account or organization.`}</p>
    </Note>
    <p>{`If you want to restrict access and visibility for a public package you own, you can make the package private. When you make a package private, its access will be updated immediately and it will be removed from the website within a few minutes of the change.`}</p>
    <h3>{`Using the website`}</h3>
    <ol>
      <li parentName="ol">{`On the `}<a parentName="li" {...{
          "href": "https://npmjs.com"
        }}>{`npm website`}</a>{`, go to the package page.`}</li>
      <li parentName="ol">{`On the package page, click `}<strong parentName="li">{`Admin`}</strong>{`.`}</li>
      <li parentName="ol">{`Under "Package Access", select "Is Package Private?"`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Update package settings`}</strong>{`.`}</li>
    </ol>
    <h3>{`Using the command line`}</h3>
    <p>{`To make a public package private on the command line, run the following command, replacing `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the name of your package:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm access restricted <package-name>
`}</code></pre>
    <p>{`For more information, see the `}<a href="https://docs.npmjs.com/cli-documentation/access"><inlineCode parentName="p">{`npm access`}</inlineCode></a>{` documentation.`}</p>
    <h2>{`Making a private package public`}</h2>
    <div className="note">
      <span className="bold">Note:</span> When you make a private package public, the package will be visible to and downloadable by all npm users.
    </div>
    <h3>{`Using the website`}</h3>
    <ol>
      <li parentName="ol">{`On the npm website, go to the package page.`}</li>
      <li parentName="ol">{`On the package page, click `}<strong parentName="li">{`Admin`}</strong>{`.`}</li>
      <li parentName="ol">{`Under "Package Access", deselect "Is Package Private?"`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Update package settings`}</strong>{`.`}</li>
    </ol>
    <h3>{`Using the command line`}</h3>
    <p>{`To make a private package public on the command line, run the following command, replacing `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the name of your package:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm access public <package-name>
`}</code></pre>
    <p>{`For more information, see the `}<a parentName="p" {...{
        "href": "/cli/access"
      }}><inlineCode parentName="a">{`npm access`}</inlineCode>{` CLI documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      